import React from 'react';
import { PhoneIcon, CheckCircleIcon } from 'lucide-react';
export function Home() {
  return <section id="home" className="relative min-h-screen flex items-center justify-center bg-cover bg-center" style={{
    backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/dD3GFNYvRYsoyixcpFxY4D/hero3.png)',
    marginTop: '0',
    paddingTop: '4rem',
    paddingBottom: '2rem'
  }} data-id="element-688">
      {/* Lighter overlay for better visibility */}
      <div className="absolute inset-0 bg-black/40" data-id="element-689"></div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center text-white" data-id="element-690">
        <p className="text-sm md:text-base uppercase tracking-wider mb-3 text-white font-semibold" data-id="element-691">
          Fleet Maintenance • DOT Inspections • Semi Truck & Trailer Repair
        </p>
        <h1 className="text-5xl md:text-7xl font-bold mb-4 drop-shadow-2xl" data-id="element-692">
          Auto Repair, Truck Repair & Diesel Engine Repair in Farmington Hills,
          Michigan
        </h1>
        <p className="text-xl md:text-2xl mb-6 max-w-3xl mx-auto drop-shadow-lg font-medium" data-id="element-693">
          Providing full-service automotive repair, diesel truck repair, fleet
          maintenance, and DOT inspections for Farmington Hills and the greater
          Detroit Metro area since 1958.
        </p>

        <a href="tel:2484788382" className="inline-flex items-center bg-white hover:bg-gray-100 text-[#B1050B] px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-xl mb-6" data-id="element-694">
          <PhoneIcon size={24} className="mr-2" data-id="element-695" />
          Call Us (248) 478-8382
        </a>

        {/* Feature Cards - Now Light */}
        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-696">
          {/* Save Time & Money */}
          <div className="bg-white/95 backdrop-blur-sm border-2 border-[#D4AF37] rounded-lg p-6 text-left shadow-xl" data-id="element-697">
            <div className="bg-[#B1050B] w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-698">
              <CheckCircleIcon size={24} className="text-white" data-id="element-699" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-700">
              Save Time & Money
            </h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-701">
              The "cheaper" mechanic down the road doesn't stand behind their
              repairs, parts and labor like we do.
            </p>
          </div>

          {/* Accurate Diagnosis */}
          <div className="bg-white/95 backdrop-blur-sm border-2 border-[#D4AF37] rounded-lg p-6 text-left shadow-xl" data-id="element-702">
            <div className="bg-[#B1050B] w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-703">
              <CheckCircleIcon size={24} className="text-white" data-id="element-704" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-705">
              Accurate Diagnosis
            </h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-706">
              Taking your vehicle somewhere else can cost more in extra trips,
              lost earnings, and repairs that should have been done right the
              first time.
            </p>
          </div>

          {/* Convenient Location */}
          <div className="bg-white/95 backdrop-blur-sm border-2 border-[#D4AF37] rounded-lg p-6 text-left shadow-xl" data-id="element-707">
            <div className="bg-[#B1050B] w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-708">
              <CheckCircleIcon size={24} className="text-white" data-id="element-709" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-710">
              Convenient Location
            </h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-711">
              Serving Farmington, Farmington Hills, Novi, Commerce, Walled Lake,
              Livonia and surrounding areas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}